import { Icon } from '@chakra-ui/react';
import { MdLanguage, MdHome, MdCardTravel } from 'react-icons/md';
import { FaUsers } from 'react-icons/fa';
import { HiDocumentReport } from 'react-icons/hi';

// ------------------- Publico
import Login from 'views/publico/signIn';
import TermsPublic from 'views/publico/terms';
import TrackingCarga from 'views/publico/webTracking';

// ------------------- Privado
// Admin
import User from 'views/privado/user';
import Report from 'views/privado/report';

// Comunes Privados
import HomeDefault from 'views/privado/home';
import Terms from 'views/privado/terms';
import Contact from 'views/privado/contact';

// Services Tracking
import WebTracking from 'views/privado/servicesTracking/webTracking';
import WebTrackingDetalle from 'views/privado/servicesTracking/webTracking/detalle';
import TrackingBl from 'views/privado/servicesTracking/trackingBl';

// Services Postsales
import EstadosCuenta from 'views/privado/servicesPostsales/estadosCuenta';
import ReclamosLinea from 'views/privado/servicesPostsales/reclamosLinea';
import ReclamosLineaDetalle from 'views/privado/servicesPostsales/reclamosLinea/detalle';
import ReporteGastos from 'views/privado/servicesPostsales/reporteGastos';
import ReporteOperativo from 'views/privado/servicesPostsales/reporteOperativo';
import Instructivos from 'views/privado/servicesPostsales/instructivos';

import { ROL_ADMINISTRATOR, ROL_CLIENT, LAYOUT_PRIVADO, LAYOUT_PUBLICO, PATH_HOME, PATH_TERMS, PATH_LOGIN, PATH_CONTACT, PATH_INSTRUCTIVOS,
	PATH_SERVICIOS_WEB_TRACKING, PATH_SERVICIOS_POST_VENTA,
	PATH_WEB_TRACKING, PATH_TRACKING_BL, PATH_ESTADOS_CUENTA,
	PATH_USUARIOS, PATH_REPORTES,
	PATH_RECLAMOS_LINEA, PATH_RECLAMOS_LINEA_DETALLE, PATH_REPORTE_GASTOS, PATH_REPORTE_OPERATIVO,PATH_WEB_TRACKING_DETALLE,PATH_TRACKING_CARGA } from 'const/CommonConst'

// Usuarios, Mensajes, Reportes

const routes = [
	// --- Home ---
	{
		name: 'Inicio',
		layout: LAYOUT_PRIVADO,
		path: PATH_HOME,
		icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
		collapse: false,
		component: HomeDefault,
		accessRoles: [],
		display: true
	},
	// --- Usuario ---
	{
		name: 'Usuarios',
		layout: LAYOUT_PRIVADO,
		path: PATH_USUARIOS,
		icon: <Icon as={FaUsers} width='20px' height='20px' color='inherit' />,
		collapse: false,
		component: User,
		accessRoles: [ ROL_ADMINISTRATOR ],
		display: true
	},
	// --- Reporte ---
	{
		name: 'Reportes',
		layout: LAYOUT_PRIVADO,
		path: PATH_REPORTES,
		icon: <Icon as={HiDocumentReport} width='20px' height='20px' color='inherit' />,
		collapse: false,
		component: Report,
		accessRoles: [ ROL_ADMINISTRATOR, ROL_CLIENT ],
		display: true
	},	
	// --- Login ---
	{
		name: 'Login',
		layout: LAYOUT_PUBLICO,
		path: PATH_LOGIN,
		collapse: false,
		component: Login,
		accessRoles: [],
		display: false
	},	
	// --- Tracking Carga ---
	{
		name: 'Tracking Carga',
		layout: LAYOUT_PUBLICO,
		path: PATH_TRACKING_CARGA,
		collapse: false,
		component: TrackingCarga,
		accessRoles: [],
		display: false
	},	
	// --- Terminos y Condiciones ---
	{
		name: 'Terminos y Condiciones de Uso',
		layout: LAYOUT_PUBLICO,
		path: PATH_TERMS,
		collapse: false,
		component: TermsPublic,
		accessRoles: [],
		display: false
	},
	{
		name: 'Terminos y Condiciones de Uso',
		layout: LAYOUT_PRIVADO,
		path: PATH_TERMS,
		collapse: false,
		component: Terms,
		accessRoles: [],
		display: false
	},
	// --- Contacto ---
	{
		name: 'Contacto',
		layout: LAYOUT_PRIVADO,
		path: PATH_CONTACT,
		collapse: false,
		component: Contact,
		accessRoles: [],
		display: false
	},
	// // --- Services Tracking ---
	{
		name: 'Servicios Web Tracking',
		path: PATH_SERVICIOS_WEB_TRACKING,
		icon: <Icon as={MdLanguage} width='20px' height='20px' color='inherit' />,
		collapse: true,
		accessRoles: [],
		display: true,
		items: [
			{
				name: 'Web Tracking Detalle' ,
				layout: LAYOUT_PRIVADO,
				path: PATH_WEB_TRACKING_DETALLE,
				component: WebTrackingDetalle,
				exact: false,
				secondary: true,
				accessRoles: [],
				display: false
			},
			{
				name: 'Web Tracking',
				layout: LAYOUT_PRIVADO,
				path: PATH_WEB_TRACKING,
				component: WebTracking,
				exact: true,
				secondary: true,
				accessRoles: [],
				display: true
			},
			{
				name: 'Tracking B/L',
				layout: LAYOUT_PRIVADO,
				path: PATH_TRACKING_BL,
				component: TrackingBl,
				exact: false,
				secondary: true,
				accessRoles: [],
				display: true
			}
		]
	},
	// // --- Services Postsales ---
	{
		name: 'Servicios Post Venta',
		path: PATH_SERVICIOS_POST_VENTA,
		icon: <Icon as={MdCardTravel} width='20px' height='20px' color='inherit' />,
		collapse: true,
		accessRoles: [],
		display: true,
		items: [
			{
				name: 'Estados de Cuenta y Factura en Línea',
				layout: LAYOUT_PRIVADO,
				path: PATH_ESTADOS_CUENTA,
				component: EstadosCuenta,
				exact: false,
				secondary: true,
				accessRoles: [],
				display: true
			},
			{
				name: 'Reclamos en Línea Detalle' ,
				layout: LAYOUT_PRIVADO,
				path: PATH_RECLAMOS_LINEA_DETALLE,
				component: ReclamosLineaDetalle,
				exact: false,
				secondary: true,
				accessRoles: [],
				display: false
			},
			{
				name: 'Reclamos en Línea',
				layout: LAYOUT_PRIVADO,
				path: PATH_RECLAMOS_LINEA,
				component: ReclamosLinea,
				exact: false,
				secondary: true,
				accessRoles: [],
				display: true
			},
			{
				name: 'Reporte de Gastos Reembolsables',
				layout: LAYOUT_PRIVADO,
				path: PATH_REPORTE_GASTOS,
				component: ReporteGastos,
				exact: false,
				secondary: true,
				accessRoles: [],
				display: true
			},
			{
				name: 'Reporte Operativo',
				layout: LAYOUT_PRIVADO,
				path: PATH_REPORTE_OPERATIVO,
				component: ReporteOperativo,
				exact: false,
				secondary: true,
				accessRoles: [],
				display: true
			},
			{
				name: 'Instructivos',
				layout: LAYOUT_PRIVADO,
				path: PATH_INSTRUCTIVOS,
				component: Instructivos,
				exact: false,
				secondary: true,
				accessRoles: [],
				display: false
			}
		]
	}	
];

export default routes;
